import {ThemeProvider, Box, Grid} from '@primer/react-brand'

import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {ContentfulFaqGroup} from '@github-ui/swp-core/components/contentful/ContentfulFaqGroup'
import {ContentfulInlineFootnotesList} from '@github-ui/swp-core/components/contentful/ContentfulInlineFootnotesList'
import {ContentfulSubnav} from '@github-ui/swp-core/components/contentful/ContentfulSubnav'
import {FootnotesProvider} from '@github-ui/swp-core/components/contentful/FootnotesContext'
import {useContentfulData} from '@github-ui/swp-core/lib/hooks/use-contentful-data'

import {toPayload} from '../../../../lib/types/payload'
import {toBrandPage} from '../../../../brand/lib/types/contentful'
import type {GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

import {PlanTypeContextProvider} from '../_context/PlanTypeContext'

import {CompareTable} from './CompareTable'
import {CtaSection} from './CtaSection'
import {HeroSection} from './HeroSection'

export default function FeaturesCopilotPlansIndex() {
  const {contentfulRawJsonResponse} = toPayload(useRoutePayload<unknown>())
  const contentfulResponse = useContentfulData(contentfulRawJsonResponse)
  const page = toBrandPage(contentfulResponse)

  const {template} = page.fields
  const {subnav, faq} = template.fields
  const {featuresCopilotPlansComparison, featuresCopilotPlansCtaSection, featuresCopilotPlansHeroSection} =
    page.ids as {
      featuresCopilotPlansComparison: GenericSectionWithIds
      featuresCopilotPlansCtaSection: GenericSectionWithIds
      featuresCopilotPlansHeroSection: GenericSectionWithIds
    }

  return (
    <FootnotesProvider>
      <PlanTypeContextProvider>
        <ThemeProvider colorMode="dark" className="lp-Copilot position-relative">
          <Box className="lp-SubNav-spacer" />

          {subnav ? (
            <ContentfulSubnav component={subnav} className="lp-Hero-subnav lp-Hero-subnav--highContrast" />
          ) : null}

          {featuresCopilotPlansHeroSection ? <HeroSection contentfulContent={featuresCopilotPlansHeroSection} /> : null}

          {featuresCopilotPlansComparison ? <CompareTable contentfulContent={featuresCopilotPlansComparison} /> : null}

          {featuresCopilotPlansCtaSection ? <CtaSection contentfulContent={featuresCopilotPlansCtaSection} /> : null}

          {faq ? (
            <section id="faq" className="lp-Section tmp-pb-8 tmp-pb-md-12 tmp-pt-8 tmp-pt-md-12">
              <Grid>
                <Grid.Column span={12} className="lp-FAQs">
                  <ContentfulFaqGroup component={faq} />
                </Grid.Column>
              </Grid>
            </section>
          ) : null}

          <Grid>
            <Grid.Column span={12}>
              <ContentfulInlineFootnotesList />
            </Grid.Column>
          </Grid>
        </ThemeProvider>
      </PlanTypeContextProvider>
    </FootnotesProvider>
  )
}
